import React from 'react';
import { HashLink } from 'react-router-hash-link';

const NavLinks = () => {
    return (
        <>
            <HashLink
              style={{textDecoration:'none'}}  className="px-4 font-extrabold text-gray-500 hover:text-red-600 transition duration-300"
                smooth
                to="/#about"
            >
                About
            </HashLink>
            <HashLink
               style={{textDecoration:'none'}} className="px-4 font-extrabold text-gray-500 hover:text-red-600 transition duration-300"
                smooth
                to="/#services"
            >
                Services
            </HashLink>
            <HashLink
               style={{textDecoration:'none'}} className="px-4 font-extrabold text-gray-500 hover:text-red-600 transition duration-300"
                smooth
                to="/#ccm"
            >
                Ccm
            </HashLink>
            <HashLink
               style={{textDecoration:'none'}} className="px-4 font-extrabold text-gray-500 hover:text-red-600 transition duration-300"
                to="/accueil"
            >
                Accueil
            </HashLink>
            <HashLink
              style={{textDecoration:'none'}}  className="text-white inline-flex items-center justify-center w-auto px-6 py-3 shadow-xl rounded-xl bg-red-600 hover:bg-red-700 transition duration-300"
                smooth
                to="/connexion"
            >
                Connexion
            </HashLink>
        </>
    );
}

export default NavLinks;
